<template>
  <div style="background-color: rgb(249, 249, 249);  width: 100%;">
    <div class="d-flex justify-center">
      <v-btn color="grey darken-2" small text class="d-flex justify-center" @click="handleGetMainHeight">
        <v-icon size="30" color="grey darken-2">mdi-chevron-down</v-icon>
      </v-btn>
    </div>
    <div class="pt-16 pb-16">
      <YA_CodeExplainerContent1 />
    </div>
    <!-- <div class="pt-16 pb-16">
      <YA_Customers />
    </div> -->
  </div>
</template>

<script>
import YA_CodeExplainerContent1 from '@/components/PowerCodeExplainer/YA_CodeExplainerContent1.vue';

export default {
  name: 'PowerCodeExplainerContent',
  components: {
    YA_CodeExplainerContent1,
  },
  data() {
    return {

    }
  },
  mounted() {

  },

  methods: {
    handleGetMainHeight() {
      this.$store.commit('HandlepowerCodeExplainerMainHeight', true);
    },
  }

};
</script>

<style scoped>

</style>